import React, { useState } from "react";
import PageOne from "./pageone";
import PageTwo from "./pagetwo";
import Header from '../header';
import { deleteChatSession } from '../../services/firestore';

// import tachyons from "tachyons";
import MultiStepProgressBar from "./MultiStepProgressBar/MultiStepProgressBar";

function MainStep() {
  // Check if there's a previous incomplete appointment
  const hasPreviousData = !!(
    localStorage.getItem('pageTwoData') ||
    localStorage.getItem('currentChatSessionId') ||
    localStorage.getItem('appointmentStep') === 'pagetwo'
  );

  const [showResumePrompt, setShowResumePrompt] = useState(hasPreviousData);

  const [page, setPage] = useState(() => {
    if (hasPreviousData) return "pagetwo";
    return "pageone";
  });

  const handleContinuePrevious = () => {
    setShowResumePrompt(false);
    // Stay on pagetwo with restored data
  };

  const handleStartNew = () => {
    // Clear all previous appointment data
    const oldSessionId = localStorage.getItem('currentChatSessionId');
    if (oldSessionId) {
      deleteChatSession(oldSessionId).catch(() => {});
    }
    localStorage.removeItem('pageTwoData');
    localStorage.removeItem('appointmentStep');
    localStorage.removeItem('currentChatSessionId');
    localStorage.removeItem('currentChatIllness');
    localStorage.removeItem('reportId');
    setShowResumePrompt(false);
    setPage("pageone");
  };

  const nextPage = (page) => {
    localStorage.setItem('appointmentStep', page);
    setPage(page);
  };

  const nextPageNumber = (pageNumber) => {
    switch (pageNumber) {
      case "1":
        localStorage.setItem('appointmentStep', 'pageone');
        setPage("pageone");
        break;
      case "2":
        localStorage.setItem('appointmentStep', 'pagetwo');
        setPage("pagetwo");
        break;

    }
  };

  return (
    <div >
     <div className='container-fluid p-0 bgInnerDiv'>
        <Header />
        <div className='container-fluid p-0 contentBody  '>

      {/* Resume or Start New prompt */}
      {showResumePrompt && (
        <div className="resumePromptOverlay">
          <div className="resumePromptBox">
            <h3>You have an incomplete appointment</h3>
            <p>Would you like to continue where you left off or start a new appointment?</p>
            <div className="resumePromptActions">
              <button className="resumeBtn" onClick={handleContinuePrevious}>
                Continue Previous
              </button>
              <button className="newApptBtn" onClick={handleStartNew}>
                Start New
              </button>
            </div>
          </div>
        </div>
      )}

      <MultiStepProgressBar page={page} onPageNumberClick={nextPageNumber} />
      {
        {
          pageone: <PageOne onButtonClick={nextPage} />,
          pagetwo: <PageTwo onButtonClick={nextPage} />,
        }[page]
      }
    </div>
    </div>
    </div>
  );
}

export default MainStep;
